import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { userPageTrackingService } from '../services/userPageTrackingService';

export const usePageTracking = (pageTitle: string) => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (user?.sub && location.pathname !== '/') {
      userPageTrackingService.trackPageVisit(
        user.sub,
        location.pathname,
        pageTitle
      );
    }
  }, [location.pathname, user, pageTitle]);
};
